import React, { Component } from 'react';

class RevisionHistoryModal extends Component {
    state = {
        animationDirection: 'right',
        isAnimating: false
    };

    componentDidUpdate(prevProps) {
        if (prevProps.documentType !== this.props.documentType) {
            const direction = this.props.documentType === 'toc_pdf' ? 'left' : 'right';
            this.setState({ animationDirection: direction, isAnimating: true });

            if (this._animTimer) clearTimeout(this._animTimer);
            this._animTimer = setTimeout(() => {
                this.setState({ isAnimating: false });
            }, 380);
        }
    }

    componentWillUnmount() {
        if (this._animTimer) clearTimeout(this._animTimer);
    }

    render() {
        const {
            show,
            station,
            version,
            availableVersions,
            documentType,
            description,
            closedDate,
            revisionHistory,
            onClose,
            onDescriptionChange,
            onClosedDateChange,
            onVersionChange,
            onDocumentTypeChange,
            onSubmit,
            onDelete,
            isSubmitDisabled,
            formatTimestamp
        } = this.props;

        if (!show) return null;

        const { animationDirection, isAnimating } = this.state;
        const isTagData = documentType === 'tag_data_pdf';
        const hasRevision = Boolean(revisionHistory?.length);

        return (
            <div
                className="modal d-block rhm-overlay"
                style={{
                    background: 'rgba(15, 23, 42, 0.55)',
                    backdropFilter: 'blur(4px)',
                    WebkitBackdropFilter: 'blur(4px)'
                }}
            >
                <style>{`
                    @keyframes rhmSlideInFromRight {
                        from { opacity: 0; transform: translateX(28px); }
                        to   { opacity: 1; transform: translateX(0); }
                    }
                    @keyframes rhmSlideInFromLeft {
                        from { opacity: 0; transform: translateX(-28px); }
                        to   { opacity: 1; transform: translateX(0); }
                    }
                    .rhm-slide-right { animation: rhmSlideInFromRight 340ms cubic-bezier(0.22, 1, 0.36, 1); }
                    .rhm-slide-left  { animation: rhmSlideInFromLeft  340ms cubic-bezier(0.22, 1, 0.36, 1); }

                    .rhm-tab-indicator {
                        transition: transform 300ms cubic-bezier(0.22, 1, 0.36, 1);
                    }
                    .rhm-card { transition: transform 180ms ease, box-shadow 180ms ease; }
                    .rhm-card:hover {
                        transform: translateY(-2px);
                        box-shadow: 0 8px 24px rgba(15, 23, 42, 0.12) !important;
                    }
                    .rhm-btn-primary { transition: transform 150ms ease, box-shadow 150ms ease, filter 150ms ease; }
                    .rhm-btn-primary:hover:not(:disabled) {
                        transform: translateY(-1px);
                        box-shadow: 0 8px 20px rgba(25, 62, 108, 0.35);
                        filter: brightness(1.05);
                    }
                    .rhm-icon-btn { transition: background 150ms ease, transform 150ms ease; }
                    .rhm-icon-btn:hover { background: #fee2e2 !important; transform: translateY(-1px); }

                    .rhm-body-scroll::-webkit-scrollbar { width: 8px; }
                    .rhm-body-scroll::-webkit-scrollbar-track { background: transparent; }
                    .rhm-body-scroll::-webkit-scrollbar-thumb {
                        background: #cbd5e1;
                        border-radius: 8px;
                    }
                    .rhm-body-scroll::-webkit-scrollbar-thumb:hover { background: #94a3b8; }

                    @media (prefers-reduced-motion: reduce) {
                        .rhm-slide-right, .rhm-slide-left,
                        .rhm-tab-indicator, .rhm-card, .rhm-btn-primary { animation: none !important; transition: none !important; }
                    }
                `}</style>

                <div className="modal-dialog modal-dialog-centered modal-lg" style={{ maxWidth: 820 }}>
                    <div
                        className="modal-content border-0 overflow-hidden d-flex flex-column"
                        style={{
                            borderRadius: 16,
                            boxShadow: '0 24px 60px rgba(15, 23, 42, 0.28)',
                            maxHeight: '90vh'
                        }}
                    >
                        {/* ================= HEADER (fixed, single row) ================= */}
                        <div
                            className="modal-header border-0 d-flex align-items-center py-3 px-3 flex-shrink-0"
                            style={{
                                background: 'linear-gradient(135deg, #1e3a5f 0%, #193e6c 55%, #2a5a94 100%)',
                                color: 'white'
                            }}
                        >
                            <div className="d-flex align-items-center gap-2 me-auto">
                                <div
                                    className="d-flex align-items-center justify-content-center"
                                    style={{
                                        width: 28,
                                        height: 28,
                                        borderRadius: 8,
                                        background: 'rgba(255,255,255,0.14)',
                                        fontSize: 14,
                                        flexShrink: 0
                                    }}
                                    aria-hidden="true"
                                >
                                    🕑
                                </div>
                                <h6 className="modal-title mb-0 fw-semibold d-flex align-items-center flex-wrap" style={{ fontSize: 16 }}>
                                    <span>Revision History</span>
                                    <span className="mx-2 opacity-50">·</span>
                                    <span className="opacity-75 fw-normal" style={{ fontSize: 14 }}>
                                        {station} · {version}
                                    </span>
                                </h6>
                            </div>

                            <button
                                type="button"
                                className="btn-close btn-close-white ms-2"
                                onClick={onClose}
                                aria-label="Close"
                            />
                        </div>

                        {/* ================= BODY (scrollable) ================= */}
                        <div className="modal-body p-0 d-flex flex-column flex-grow-1 rhm-body-scroll" style={{ overflowY: 'auto', minHeight: 0 }}>
                            {/* ---- Toolbar: tabs + version ---- */}
                            <div className="px-4 py-2 bg-white border-bottom border-2 flex-shrink-0" style={{ borderColor: '#b8c2cf' }}>
                                <div className="row g-2 align-items-end">
                                    <div className="col-md-7">
                                        {/* <label className="form-label text-muted text-uppercase fw-semibold mb-1" style={{ fontSize: 11, letterSpacing: 0.4 }}>
                                            Revision History For
                                        </label> */}

                                        {/* Segmented tab control */}
                                        <div
                                            role="tablist"
                                            aria-label="Revision document type"
                                            className="position-relative d-inline-flex p-1 rounded-3 w-100"
                                            style={{ background: '#e4e9f0', maxWidth: 320 }}
                                        >
                                            <span
                                                className="rhm-tab-indicator position-absolute rounded-3"
                                                aria-hidden="true"
                                                style={{
                                                    top: 4,
                                                    bottom: 4,
                                                    left: 4,
                                                    width: 'calc(50% - 4px)',
                                                    background: '#ffffff',
                                                    boxShadow: '0 2px 6px rgba(15, 23, 42, 0.14)',
                                                    border: '2px solid #aab6c4',
                                                    transform: isTagData ? 'translateX(0)' : 'translateX(100%)'
                                                }}
                                            />
                                            <button
                                                type="button"
                                                role="tab"
                                                aria-selected={isTagData}
                                                onClick={() => onDocumentTypeChange('tag_data_pdf')}
                                                className="position-relative border-0 bg-transparent flex-fill rounded-3 py-2 px-2"
                                                style={{
                                                    zIndex: 1,
                                                    fontSize: 13,
                                                    fontWeight: isTagData ? 600 : 500,
                                                    color: isTagData ? '#1e3a5f' : '#64748b',
                                                    transition: 'color 200ms ease'
                                                }}
                                            >
                                                Tag Data PDF
                                            </button>
                                            <button
                                                type="button"
                                                role="tab"
                                                aria-selected={!isTagData}
                                                onClick={() => onDocumentTypeChange('toc_pdf')}
                                                className="position-relative border-0 bg-transparent flex-fill rounded-3 py-2 px-2"
                                                style={{
                                                    zIndex: 1,
                                                    fontSize: 13,
                                                    fontWeight: !isTagData ? 600 : 500,
                                                    color: !isTagData ? '#1e3a5f' : '#64748b',
                                                    transition: 'color 200ms ease'
                                                }}
                                            >
                                                TOC PDF
                                            </button>
                                        </div>
                                    </div>

                                    <div className="col-md-5 d-flex align-items-center gap-2">
                                        <label className="form-label text-muted text-uppercase fw-semibold mb-1 mt-1" style={{ fontSize: 11, letterSpacing: 0.4 }}>
                                            Version
                                        </label>
                                        <select
                                            className="form-select rounded-3 border-2"
                                            value={version}
                                            onChange={(e) => onVersionChange(e.target.value)}
                                            style={{ borderColor: '#aab6c4', fontSize: 14, boxShadow: 'none' }}
                                        >
                                            {(availableVersions || []).map((item) => (
                                                <option key={item.id} value={item.version}>
                                                    v{item.version}
                                                </option>
                                            ))}
                                        </select>
                                    </div>
                                </div>
                            </div>

                            {/* ---- Animated swipe content ---- */}
                            <div
                                key={documentType}
                                className={isAnimating ? (animationDirection === 'left' ? 'rhm-slide-left' : 'rhm-slide-right') : ''}
                                style={{ padding: '14px 20px 16px', background: '#f8fafc' }}
                            >
                                {/* Add revision form */}
                                <div className="bg-white rounded-3 border border-2 mb-3 p-3" style={{ borderColor: '#b8c2cf' }}>
                                    <div className="d-flex align-items-center mb-2">
                                        <span
                                            className="d-inline-block rounded-circle me-2"
                                            style={{ width: 8, height: 8, background: '#193e6c' }}
                                        />
                                        <strong className="text-uppercase fw-semibold" style={{ color: '#1e3a5f', fontSize: 12, letterSpacing: 0.4 }}>
                                            {hasRevision ? 'Update Revision' : 'Add New Revision'}
                                        </strong>
                                    </div>

                                    <div className="mb-2">
                                        <label className="form-label text-muted mb-1" style={{ fontSize: 12 }}>
                                            Description
                                        </label>
                                        <textarea
                                            className="form-control rounded-3 border-2"
                                            rows="4"
                                            value={description}
                                            onChange={(e) => onDescriptionChange(e.target.value)}
                                            placeholder="Enter revision description"
                                            style={{ borderColor: '#aab6c4', fontSize: 14, resize: 'vertical', boxShadow: 'none' }}
                                        />
                                    </div>

                                    <div className="row g-2 align-items-end">
                                        <div className="col-md-6">
                                            <label className="form-label text-muted mb-1" style={{ fontSize: 12 }}>
                                                Closed Date
                                            </label>
                                            <input
                                                type="date"
                                                className="form-control rounded-3 border-2"
                                                value={closedDate}
                                                onChange={(e) => onClosedDateChange(e.target.value)}
                                                style={{ borderColor: '#aab6c4', fontSize: 14, boxShadow: 'none' }}
                                            />
                                        </div>
                                        <div className="col-md-6 text-md-end">
                                            <button
                                                className="btn rhm-btn-primary text-white fw-semibold rounded-3 px-3 py-2"
                                                onClick={onSubmit}
                                                disabled={isSubmitDisabled}
                                                style={{
                                                    fontSize: 13.5,
                                                    border: 'none',
                                                    background: isSubmitDisabled
                                                        ? '#94a3b8'
                                                        : 'linear-gradient(135deg, #1e3a5f 0%, #193e6c 100%)',
                                                    cursor: isSubmitDisabled ? 'not-allowed' : 'pointer',
                                                    opacity: isSubmitDisabled ? 0.7 : 1
                                                }}
                                            >
                                                {hasRevision ? 'Update Revision' : 'Add Revision'}
                                            </button>
                                        </div>
                                    </div>
                                </div>

                                {/* List header */}
                                <div className="d-flex align-items-center justify-content-between mb-2">
                                    <h6 className="mb-0 fw-semibold" style={{ color: '#1e3a5f', fontSize: 13.5 }}>
                                        Revision History
                                    </h6>
                                    {revisionHistory && revisionHistory.length > 0 && (
                                        <span className="badge rounded-pill fw-semibold" style={{ background: '#e4e9f0', color: '#475569', fontSize: 11 }}>
                                            {revisionHistory.length} {revisionHistory.length === 1 ? 'entry' : 'entries'}
                                        </span>
                                    )}
                                </div>

                                {revisionHistory && revisionHistory.length > 0 ? (
                                    revisionHistory.map((item) => (
                                        <div
                                            key={item.id}
                                            className="rhm-card bg-white rounded-3 border border-2 mb-2"
                                            style={{
                                                borderColor: '#b8c2cf',
                                                borderLeft: '4px solid #193e6c',
                                                boxShadow: '0 1px 3px rgba(15, 23, 42, 0.06)'
                                            }}
                                        >
                                            <div className="p-3">
                                                <div className="d-flex justify-content-between align-items-start">
                                                    <div className="flex-grow-1" style={{ minWidth: 0 }}>
                                                        <div className="text-uppercase text-muted fw-semibold mb-1" style={{ fontSize: 10.5, letterSpacing: 0.4 }}>
                                                            Description
                                                        </div>
                                                        <div className="mb-2" style={{ color: '#0f172a', fontSize: 13.5, lineHeight: 1.5, whiteSpace: 'pre-wrap' }}>
                                                            {item.description}
                                                        </div>

                                                        <div className="d-flex flex-wrap gap-3">
                                                            <div>
                                                                <div className="text-uppercase text-secondary fw-semibold mb-1" style={{ fontSize: 10, letterSpacing: 0.4 }}>
                                                                    Closed Date
                                                                </div>
                                                                <div className="fw-medium" style={{ fontSize: 12.5, color: '#334155' }}>
                                                                    {item.closed_date
                                                                        ? new Date(item.closed_date).toLocaleDateString('en-GB')
                                                                        : '—'}
                                                                </div>
                                                            </div>
                                                            {formatTimestamp && item.created_at && (
                                                                <div>
                                                                    <div className="text-uppercase text-secondary fw-semibold mb-1" style={{ fontSize: 10, letterSpacing: 0.4 }}>
                                                                        Created
                                                                    </div>
                                                                    <div className="fw-medium" style={{ fontSize: 12.5, color: '#334155' }}>
                                                                        {formatTimestamp(item.created_at)}
                                                                    </div>
                                                                </div>
                                                            )}
                                                            <div>
                                                                <div className="text-uppercase text-secondary fw-semibold mb-1" style={{ fontSize: 10, letterSpacing: 0.4 }}>
                                                                    Author
                                                                </div>
                                                                <div className="fw-medium" style={{ fontSize: 12.5, color: '#334155' }}>
                                                                    {item.author || 'Unknown author'}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <button
                                                        type="button"
                                                        className="rhm-icon-btn ms-3 rounded-3 d-inline-flex align-items-center gap-1 fw-semibold"
                                                        onClick={() => onDelete(item.id)}
                                                        aria-label="Delete revision"
                                                        style={{
                                                            border: '2px solid #fecaca',
                                                            background: '#fff',
                                                            color: '#dc2626',
                                                            padding: '5px 10px',
                                                            fontSize: 12,
                                                            cursor: 'pointer',
                                                            whiteSpace: 'nowrap'
                                                        }}
                                                    >
                                                        <span aria-hidden="true">🗑</span>
                                                        Delete
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    ))
                                ) : (
                                    <div className="text-center bg-white rounded-3 border border-2 border-dashed" style={{ borderColor: '#b8c2cf', padding: '28px 16px' }}>
                                        <div className="mb-1" style={{ fontSize: 26, opacity: 0.5 }} aria-hidden="true">
                                            📄
                                        </div>
                                        <div className="fw-semibold" style={{ color: '#64748b', fontSize: 13.5 }}>
                                            No revision history available
                                        </div>
                                        <div className="text-secondary" style={{ fontSize: 12, marginTop: 2 }}>
                                            Add a revision above to get started
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>

                        {/* Footer removed — modal closes via X in header or backdrop */}
                    </div>
                </div>
            </div>
        );
    }
}

export default RevisionHistoryModal;